<template>
  <navbar placement="top" type="default">
    <a slot="brand" :href="`/`" class="navbar-brand"><img :src="logoPath" class="logo-blue" alt="ITMO"></a>
    <li><a :href="`/`" class="hover">{{ $t('mainMenu.projects') }}</a></li>
    <li v-if="isRegisteredUser"><a :href="'/personal'" class="hover">{{ $t('mainMenu.myProjects') }}</a></li>
    <li v-if="!isRegisteredUser"><router-link :to="`/login`" class="hover"><i class="fa fa-sign-in"></i>&nbsp; {{ $t('mainMenu.signIn') }}</router-link></li>
    <li v-if="!isRegisteredUser && canRegister"><a :href="`/${lang}/register`" class="hover">{{ $t('mainMenu.signUp') }}</a></li>
    <li><a :href="`/s/questions`" class="hover"> {{ $t('layout.questions') }} </a></li>
    <li v-if="canSelectLang" class="dropdown">
      <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
        <div><span> {{ langs.find(l => l.code === lang).localName }} <i class="fa fa-angle-down"></i></span></div></a>
      <ul class="dropdown-menu">
        <li v-for="l in langs"><a href="#" @click.prevent="setLang(l.code)">{{l.localName}}</a></li>
      </ul>
    </li>
    <li slot="right" v-if="isRegisteredUser" class="dropdown">
      <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
        <div v-if="user" class="user-block">{{ user.lastName}} {{ user.firstName }} {{ user.middleName }} <i class="fa fa-angle-down"></i></div></a>
      <ul class="dropdown-menu">
        <li><router-link to="/profile"><i class="fa fa-cog"></i>&nbsp; {{ $t('mainMenu.profile') }}</router-link></li>
        <li><a href="/logout"><i class="fa fa-sign-out"></i>&nbsp; {{ $t('mainMenu.logout') }}</a></li>
      </ul>
    </li>
  </navbar>
</template>
<script>

  import commonModel from '../../models/common';
  import userModel from '../../models/user';
  import { navbar, dropdown } from 'vue-strap';

  export default {
    components: {
      navbar, dropdown
    },
    name: 'MainMenu',
    data()
    {
      return {
        lang: null,
        langs: [],
        user: userModel.getCurrentUser(),
      }
    },
    computed: {
      isRegisteredUser()
      {
        return userModel.isRegisteredUser();
      },
      currentLangName()
      {
        return this.lang || '?';
      },
      canRegister() {
        return window._STATE.isRegisterEnabled;
      },
      canSelectLang() {
        return window._STATE.areTranslationsEnabled;
      },
      logoPath() {
        const logoLang = this.lang === 'ru' ? 'ru' : 'en';
        return require(`../../assets/images/itmo-${logoLang}.png`);
      }
    },
    methods: {
      async setLang(code)
      {
        await commonModel.setLang(code);
        window.location.reload();
      },
    },
    created()
    {
      if (this.isRegisteredUser) {
        this.$router.push('/');
      }
      this.lang = commonModel.getCurrentLang();
      this.langs = commonModel.getLangs();
    }
  }

</script>
<style scoped>
  .navbar
  {
    margin: 0px;
    border: none;
    background: #fff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.17);
  }

  .navbar-default .navbar-nav > li > a,
  .navbar-default .navbar-nav > li > .dropdown-menu > li > a
  {
    color: #333;
    padding: 16.5px 25px;
  }

  .navbar-default .navbar-nav > li > a:hover, .navbar-default .navbar-nav > li > a:focus,
  .navbar-default .navbar-nav > li > .dropdown-menu > li > a:hover, .navbar-default .navbar-nav > li > .dropdown-menu > li > a:focus
  {
    background: #d9dee4;
  }
  .nav-menu
  {
    width: 100%;
    height: 53px;
    position: relative;
    background: #fff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.17);
  }
  .menu-container
  {
    display: flex;
    justify-content: space-between;
    height: 100%;
    max-width: 1200px;
    min-width: 800px;
    margin: 0 auto;
  }
  .menu
  {
    display: flex;
    height: 100%;
    align-items: center;
  }
  .menu li
  {
    height: 100%;
  }
  .menu li a:hover, .menu li a:focus
  {
    text-decoration: none;
  }
  .menu>li>a.router-link-active
  {
    border-top-color: #1946ba;
  }
  .menu li.icon-item a
  {
    width: 60px;
    min-width: 0;
    padding: 0 0 3px 0;
  }
  .menu-dropdown, .menu li a
  {
    position: relative;
    display: flex;
    height: 100%;
    min-width: 100px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0 19px;
  }
  .menu li a
  {
    letter-spacing: -0.2px;
    text-align: left;
    color: #4a4a4a;
    border-top: 3px solid transparent;
    padding-bottom: 2px;
  }
  .menu-list
  {
    display: none;
    position: absolute;
    width: 100%;
    top: 100%;
    z-index: 100;
    background: #fff;
    border: 1px solid #d9dee4;
  }
  .menu-dropdown:hover, .menu-dropdown:focus, .menu li a.hover:hover, .menu li a.hover:focus
  {
    background: #d9dee4;
  }
  .menu-dropdown:hover .menu-list, .menu-dropdown:focus .menu-list
  {
    display: block;
  }
  .menu-list li a
  {
    display: block;
    color: #5a738e;
    padding: 12px 20px;
  }
  .menu-list li a:hover, .menu-list li a:focus
  {
    text-decoration: none;
    color: #262626;
    background-color: #f5f5f5;
  }
  a.navbar-brand {
    padding: 0;
  }
  .logo-blue
  {
    width: 256px;
    object-fit: contain;
    height: 100%;
  }
</style>
